import { LedgerType } from "../models/LedgerBase";
import { TransactionType } from "../models/TransactionBase";

export type GetGroupsFilter = {
  transactionType?: TransactionType[];
  ledgerType?: LedgerType[];
  dataSource?: string[];
  asset?: string[];
  status?: StatusOption[];
  datePeriod?: Date[];
  searchQuery?: string;
};

export type GetGroupsRequest = {
  limit?: number;
  start?: number;
  sort?: GetGroupsRequestSortOption;
} & GetGroupsFilter;

export enum StatusOption {
  NeedsReview = "NeedsReview",
}

export enum GetGroupsRequestTransactionType {
  Trade = "Trade",
  Receive = "Receive",
  Send = "Send",
  Rebase = "Rebase",
  Orders = "Orders",
}

export enum GetGroupsRequestSortOption {
  DateAscending = "DateAscending",
  DateDescending = "DateDescending",
}
